import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { model } from '../../AppGrid/ViewHistoryTable';

const ViewHistoryTable = model.createGridBase()
const ViewHistoryGrid = () => {
	const [searchParams] = useSearchParams();
	const clientCommandId = searchParams.get('clientCommandId');
	const [activeRecord, setActiveRecord] = useState(null);
	const handleOnOpenForm = (record) => {
		setActiveRecord(record);
	};
	return (
		<Box>
			<ViewHistoryTable onOpenForm={handleOnOpenForm} parentFilters={{ filter: [{ "value": clientCommandId, "property": "ClientCommandId" }] }} />
		</Box>
	);
};

export default ViewHistoryGrid;
